import axios from "axios";
import {fulFilledCb, onRejectedCb} from "./http-common";

export const HttpService = axios.create();

HttpService.defaults.baseURL = `${
  import.meta.env.VITE_CORPORA_SERVICE_URL as string
}`;

